// Only acknowledge confirmed incoming messages in the currently rendered stream.
export const playerReadAcknowledgement = (messages, roomId, agent = {}) => {
  const ids = [...new Set((messages || []).filter(message =>
    message?.conversation_id === roomId && message.sender_role !== 'player'
    && !message.deleted && !message.read_by_player
    && typeof message.id === 'string' && message.id.length <= 160
    && message.id && !message.id.startsWith('temp_')
  ).map(message => message.id))].slice(-500);
  if (!roomId || !ids.length) return null;
  return {
    last_message_id: ids[ids.length - 1], rendered_message_ids: ids,
    ...(agent.id ? { agent_id: agent.id } : {}),
    ...(agent.name ? { agent_name: agent.name } : {}),
  };
};
